<template>
    <div class="OverviewBox">
        <h1>Overview</h1>

        <ul>
            <li v-for="(type,idx) in types"  :key="idx">{{ type.title }}</li>
        </ul>
    </div>
</template>

<script>
    import TableauxApi from "../scripts/TableauxApi";

    var questionBox = {
        name: "Overview",
        data: function(){
            return {
                types: []
            }
        },
        created: function () {
            let $this = this;
            TableauxApi.set("GET", "planner").execute().then((result) => {
                if(result.success){
                    result.object.forEach(function(v){
                        $this.types.push(v);
                    });
                }
            });
        }
    };

    export default questionBox;
</script>